import withLoader from "../../components/layouts/WithLoader";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import SocieteService from "../../services/Societe";
import KPISaleService from "../../services/KPISaleService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import { Link } from "react-router-dom";
import BanqueService from "../../services/Banque";

const KPIPayements = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();
  const animatedComponentBAs = makeAnimated();

  const [yearPlaceholder, setYearPlaceholder] = useState("");
  // const [toByYear, setToByYear] = useState([]);
  const [payementAchat, setPayementAchat] = useState([]);
  const [payementVente, setPayementVente] = useState([]);
  const [banquesAccount, setBanquesAccount] = useState([]);

  const [allPayementAchat, setAllPayementAchat] = useState(0);
  const [allPayementVente, setAllPayementVente] = useState(0);

  const [isClicked, setIsClicked] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [idBA, setIdBA] = useState(null);

  const [options, setOptions] = useState([]);


  const [selectedYear, setSelectedYear] = useState(null);
  const [finalYear, setFinalYear] = useState("");
  const [yearsOptions, setYearsOptions] = useState([]);
  const [details, setDetails] = useState(null);
  const [activeTab, setActiveTab] = useState('none');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
    setFinalYear(selectedOption.label);
    console.log(`Option selected:`, selectedOption);
  };

  useEffect(() => {
    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
      .then((response) => {
        if (response.data["success"] !== undefined) {
          const today = new Date();

          const yyyy = today.getFullYear();

          setFinalYear(yyyy);
          setYearPlaceholder(yyyy);

          const yearsOptions = response.data["success"].years.map(
            (year, index) => ({
              value: index,
              label: year,
            })
          );
          setYearsOptions([...yearsOptions]);
        }
      })
      .catch((error) => {
        console.log("error: " + error);
      });

    BanqueService.getAllAccounts()
      .then((response) => {
        console.log(response)
        const updatedOptions = response.data["success"].map((ba) => ({
          value: ba.idBankAccount,
          label: ba.rib + "-" + ba.name + "-" + ba.agenceLocalisation,
        }));
        setOptions([...updatedOptions]);
      })
      .catch((error) => {

      });
  }, []);
  const getLabel = (key) => {
    const labels = {
      eEspece: "Espèce",
      eEnligne: "TPE",
      eChequeTraites: "Chèque",
      eVirement: "Virement",
      eCarteCadeau: "Carte cadeau",
      sEspece: "Espèce",
      sEnligne: "TPE",
      sChequeTraites: "Chèque",
      sVirement: "Virement",
      sCarteCadeau: "Carte cadeau",
    };
    return labels[key] || key;
  };

  const getKPISale = (e) => {
    setIsClicked(true);
    startLoading();
    KPISaleService.getPayementsByYear(
      idBA,
      getCurrentUserId(),
      finalYear,
      "accept",
      0
    )
      .then((response) => {
        setPayementVente(response.data);
      })
      .catch((error) => {
        console.log("error: " + error);
      })
      .finally(() => {
        stopLoading();
      });
    KPISaleService.getPayementsByYear(
      idBA,
      getCurrentUserId(),
      finalYear,
      "accept",
      1
    )
      .then((response) => {
        setPayementAchat(response.data);
      })
      .catch((error) => {
        console.log("error: " + error);
      })
      .finally(() => {
        stopLoading();
      });

    KPISaleService.getAllPayementsByYear(
      idBA,
      getCurrentUserId(),
      finalYear,
      "accept",
      0
    )
      .then((response) => {
        setAllPayementVente(response.data?.[0].totalAmountInitialPrice);
      })
      .catch((error) => {
        console.log("error: " + error);
      })
      .finally(() => {
        stopLoading();
      });
    KPISaleService.getAllPayementsByYear(
      idBA,
      getCurrentUserId(),
      finalYear,
      "accept",
      1
    )
      .then((response) => {
        setAllPayementAchat(response.data?.[0].totalAmountInitialPrice);
      })
      .catch((error) => {
        console.log("error: " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const getKPISaleDetails = (e) => {
    setIsClicked(true);
    startLoading();
    KPISaleService.getPayementsByBankAccountAndYear(
      idBA,
      getCurrentUserId(),
      finalYear
    )
      .then((response) => {
        console.log(response.data)
        // setPayementVente(response.data);
        setDetails(response.data.success)
      })
      .catch((error) => {
        console.log("error: " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };


  const resultTableAchat = () => {
    if (isClicked && payementAchat.length > 0) {
      return (
        <>
          <div className="col-md-12 col-sm-6 col-12">
            <div className="info-box bg-danger">
              <span className="info-box-icon">
                <i class="fa-solid fa-minus"></i>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">
                  Total Achat pour {finalYear}
                </span>
                <span className="info-box-number">{allPayementAchat}</span>
              </div>
            </div>
          </div>

          <div className="card card-danger">
            <div className="card-header">
              <h3 className="card-title">
                Resultat de l'année Achat: {finalYear}
              </h3>
            </div>
            <div className="card-body p-0">
              <table className="table table-condensed">
                <thead>
                  <tr>
                    <th style={{ width: 10 }}>Mois</th>
                    <th style={{ width: 20 }}>Total Montant</th>
                  </tr>
                </thead>
                <tbody>
                  {payementAchat &&
                    payementAchat.map((element) => (
                      <tr>
                        <td>
                          {element?.id?.month}-{finalYear}
                        </td>
                        <td>{element?.totalAmountInitialPrice}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    }
  };
  const resultTableVente = () => {
    if (isClicked && payementVente.length > 0) {
      return (
        <>
          <div className="col-md-12 col-sm-6 col-12">
            <div className="info-box bg-success">
              <span className="info-box-icon">
                <i class="fa-solid fa-plus"></i>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">
                  Total Vente pour {finalYear}
                </span>
                <span className="info-box-number">{allPayementVente}</span>
              </div>
            </div>
          </div>
          <div className="card card-success">
            <div className="card-header">
              <h3 className="card-title">
                Resultat de l'année Vente: {finalYear}
              </h3>
            </div>
            <div className="card-body p-0">
              <table className="table table-condensed">
                <thead>
                  <tr>
                    <th style={{ width: 10 }}>Mois</th>
                    <th style={{ width: 20 }}>Total Montant</th>
                  </tr>
                </thead>
                <tbody>
                  {payementVente &&
                    payementVente.map((element) => (
                      <tr>
                        <td>
                          {element?.id?.month}-{finalYear}
                        </td>
                        <td>{element?.totalAmountInitialPrice}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      );
    }
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setIdBA(selectedOption.value);
  };
  const titleMapping = {
    none: "Non rapproché",
    accept: "Accepté",
    reject: "Rejeté",
    refuseDef: "Rejeté définitivement",
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  {" "}
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Les KPI des paiements
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card ">
                <div className="card-header">
                  <h3 className="card-title">Choisir un an</h3>
                </div>
                <div class="card-body">
                  <div className="row">
                    <div className="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir un compte</label>
                        <Select
                          value={selectedOption}
                          closeMenuOnSelect={true}
                          components={animatedComponentBAs}
                          options={options}
                          onChange={handleChange}
                          defaultValue={selectedOption}
                        // placeholder={"Tous"}
                        />
                      </div>
                    </div>
                    <div className="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir l'année </label>
                        <Select
                          value={selectedYear}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={yearsOptions}
                          onChange={handleYearChange}
                          defaultValue={selectedYear}
                          placeholder={yearPlaceholder}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <button
                    type="submit"
                    onClick={getKPISale}
                    className="btn btn-dark float-right mx-2"
                  >
                    Valider
                  </button>
                  <button
                    type="submit"
                    onClick={getKPISaleDetails}
                    className="btn btn-dark float-right"
                  >
                    Details
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {details && <div className="col-12 col-sm-12">
        <div className="card card-dark card-outline card-outline-tabs ">
          <div className="card-header p-0 pt-1">
            <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
              {Object.entries(titleMapping).map(([key]) => (
                <li className="nav-item" key={key}>
                  <a
                    className={`nav-link nav-link-w ${activeTab === key ? 'active' : ''}` }
                    style={{ color: "black"}}
                    onClick={() => handleTabClick(key)}
                    role="tab"
                    aria-controls={`custom-tabs-two-${key}`}
                    aria-selected={activeTab === key}
                  >
                    {titleMapping[key]}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="card-body">
            <div className="tab-content">
              {Object.entries(details).map(([key, value]) => (
                <div
                  key={key}
                  className={`tab-pane fade ${activeTab === key ? 'show active' : ''}`}
                  id={`custom-tabs-two-${key}`}
                  role="tabpanel"
                >
                  <section className="content">
                    <div key={key} className="card-footer">
                      <h4 className="my-3 " 
                      >{titleMapping[key]}</h4>

                      {/* Entrée Section */}
                      {value.entree && (
                        <div>
                          <div className="my-2"><strong>Les Entrées</strong></div>
                          <div className="d-flex justify-content-between flex-wrap">
                            {Object.entries(value.entree).map(([entryKey, entryValue]) =>
                              entryKey !== "eTotal" && (
                                <div key={entryKey} className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                                  <span className="info-box-icon">
                                    <i className="fas fa-money-bill"></i>
                                  </span>
                                  <div className="info-box-content">
                                    <span className="info-box-text">{getLabel(entryKey)}</span>
                                    <span className="info-box-number">{entryValue}</span>
                                    <div className="progress">
                                      <div className="progress-bar" style={{ width: "70%" }}></div>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      )}

                      {/* Sortie Section */}
                      {value.sortie && (
                        <div>
                          <div className="my-2"><strong>Les Sorties</strong></div>
                          <div className="d-flex justify-content-between flex-wrap">
                            {Object.entries(value.sortie).map(([sortieKey, sortieValue]) =>
                              sortieKey !== "sTotal" && (
                                <div key={sortieKey} className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                                  <span className="info-box-icon">
                                    <i className="fas fa-money-bill"></i>
                                  </span>
                                  <div className="info-box-content">
                                    <span className="info-box-text">{getLabel(sortieKey)}</span>
                                    <span className="info-box-number">{sortieValue}</span>
                                    <div className="progress">
                                      <div className="progress-bar" style={{ width: "70%" }}></div>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </section>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>}
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">{resultTableVente()}</div>
            <div className="col-sm-6">{resultTableAchat()}</div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default withLoader(KPIPayements);
